import { Text } from '@airwallex/typography';
import React, { useContext } from 'react';
import { formatCurrency } from '@airwallex/awx-currency-formatter';
import { VStack } from '@airwallex/stacks';
import { TotalRow, Divider } from './v1/style';
import { Trans, useTranslation } from 'react-i18next';
import { StoreContext } from '@/providers/storeProvider';
import { useTabletOrMobile } from '@/hooks/useMediaQuery';
import DiscountRows from '@/components/common/DiscountRows';

const TotalSection: React.FC = () => {
  const { t } = useTranslation();
  const { invoiceData } = useContext(StoreContext);
  const { invoice } = invoiceData;

  const {
    subtotalAmount,
    totalTaxAmountExcludeDiscount,
    totalAmount,
    totalAmountExcludeTax,
    currency,
    defaultTaxPercent,
  } = invoice;
  const isTabletOrMobile = useTabletOrMobile();

  return (
    <VStack
      data-test="total-section"
      space="12px"
      style={{
        margin: '0 8px',
        paddingLeft: isTabletOrMobile ? 8 : '50%',
        paddingRight: 8,
      }}
    >
      <TotalRow>
        <Text variant="body">{t('invoice.subtotal')}</Text>
        <Text variant="body">
          {formatCurrency({
            amount: subtotalAmount ?? 0,
            currency,
            showSymbol: true,
            showCode: false,
          })}
        </Text>
      </TotalRow>
      <DiscountRows discounts={invoice.discounts} currency={currency} variant="row" />
      {invoice.discounts && invoice.discounts.length > 0 && typeof totalAmountExcludeTax === 'number' && (
        <TotalRow>
          <Text variant="body">{t('invoice.tax.excluding')}</Text>
          <Text variant="body">
            {formatCurrency({
              amount: totalAmountExcludeTax,
              currency,
              showSymbol: true,
              showCode: false,
            })}
          </Text>
        </TotalRow>
      )}
      <TotalRow>
        <Text variant="body">
          <Trans i18nKey="invoice.tax.percentage" t={t} values={{ percentage: defaultTaxPercent }} />
        </Text>
        <Text variant="body">
          {formatCurrency({
            amount: totalTaxAmountExcludeDiscount ?? 0,
            currency,
            showSymbol: true,
            showCode: false,
          })}
        </Text>
      </TotalRow>
      <TotalRow>
        <Divider />
      </TotalRow>
      <TotalRow>
        <Text variant="headline300">{t('invoice.total', { currency })}</Text>
        <Text variant="headline300">
          {formatCurrency({
            amount: totalAmount ?? 0,
            currency,
            showSymbol: true,
            showCode: false,
          })}
        </Text>
      </TotalRow>
    </VStack>
  );
};

export default TotalSection;
